/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConfirmarUsuarioAliases {
  LOADER_CONF_USUARIO = 'loader-conf-usuario',
  PANEL_CONF_USUARIO = 'panel-conf-usuario',
}
export { ConfirmarUsuarioAliases };
